import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "../base-service";
import { catchError, finalize, map } from "rxjs/operators";
import { Partner } from "src/app/domain/partner";
import { AreaMap } from "src/app/domain/GS/area-map";
import { EAreaMapType } from "src/app/domain/enum/area-map-type";

@Injectable({
    providedIn: 'root',
})
export class AreaMapService extends BaseService {

    private serviceUrl = `${environment.GSServiceBaseUrl}api/areamap`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getAreaMapFromStrategy(strategyId: number, type?: EAreaMapType) {

        let params = new HttpParams();
        if (type) {
            params = params.set('type', type);
        }
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Strategy/${strategyId}`, this.generateHeaderWithParametersWithBearer(params, environment.GSBearer)).pipe(
            catchError(this.handleError<any>('getAreaMapFromStrategy')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AreaMap[]) => {
                return response.map((item: AreaMap) => {
                    return AreaMap.mapFromJSON(item);
                });
            }));
    }

}

